export const CODES = {
    200 : 'OK',
    400 : 'Invalid Parameters',
    401 : 'Unauthorized',
    403 : 'Forbidden',
    404 : 'Not Found',
    500 : 'Internal Server Error',
}
